import axios from '@/services/axios-config';
import { AxiosResponse } from '@/plugins/axios';

import {
  Garde,
  Executant,
  Organisme,
  UtilisateurExterne,
  HistoriqueDpa,
  UpdateUtilisateurData
} from '@/services/api/types';

// GARDES
export async function getGardesFromApi(): Promise<AxiosResponse<Garde[]>> {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}garde/liste_recherche_principale`,
    {}
  );
}
export async function getGardesAValiderFromApi(): Promise<
  AxiosResponse<Garde[]>
> {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}garde/liste_a_valider`,
    {}
  );
}

// DPA
export async function getDpaFromApi(): Promise<AxiosResponse<HistoriqueDpa[]>> {
  return await axios.get(`${process.env.VUE_APP_API_URL}dpa/liste_jours`, {});
}

export async function getDpaPdfFromApi(dpaData: {
  dateDpa: string | null;
}): Promise<AxiosResponse<any>> {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}dpa/pdf_jour`,
    dpaData,
    {
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}

export async function getOrganismesFromApi(): Promise<
  AxiosResponse<Organisme[]>
> {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}organisme/public/liste`,
    {}
  );
}

export async function getAmCibleFromApi(
  executant: Executant
): Promise<AxiosResponse<any>> {
  const requestBody = {
    executant: executant
  };
  return await axios.post(
    `${process.env.VUE_APP_API_URL}garde/liste_am_eligible`,
    requestBody
  );
}

export async function getUtilisateurExterneFromApi(): Promise<
  AxiosResponse<UtilisateurExterne>
> {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}utilisateur_externe/informations`,
    {}
  );
}

export async function updateEtatApi(
  gardesToUpdate: Garde[],
  action: number
): Promise<AxiosResponse<any>> {
  const requestBody = {
    gardesToUpdate: gardesToUpdate,
    action: action
  };

  return await axios.post(
    `${process.env.VUE_APP_API_URL}garde/changer_etat_garde`,
    requestBody
  );
}

export async function transfertEtatApi(
  gardesToUpdate: Garde[],
  numAmCible: string
): Promise<AxiosResponse<any>> {
  const requestBody = {
    gardesToUpdate: gardesToUpdate,
    numAmCible: numAmCible
  };

  return await axios.post(
    `${process.env.VUE_APP_API_URL}garde/transfert_garde`,
    requestBody
  );
}

export async function updateUtilisateurApi(
  userData: UpdateUtilisateurData
): Promise<any> {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}utilisateur_externe/update`,
    userData
  );
}

export async function requestPasswordApi(userData: {
  email: string;
  login: string;
}): Promise<any> {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}reset-password/public/passwordrequest`,
    userData
  );
}

export async function resetPasswordApi(userData: {
  token: string;
  password: string;
}): Promise<any> {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}reset-password/public/reset`,
    userData
  );
}

export async function updateCguAccepted(): Promise<any> {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}utilisateur_externe/accepte_cgu`
  );
}
